export const ITEXTFIELD_PROP_NAMES = {
    text: '#text',
};
export const ICDATASECTION_PROP_NAMES = {
    cdata_section: '#cdata-section',
};
export const IEXTENSION_PROP_NAMES = {
    foray_isForaySegment: 'foray:IsForaySegment',
};
export const ICOMPUTATION_PROP_NAMES = {
    name: '@Name',
    c: '@c',
    type: '@Type',
    extension: 'Extension',
};
export const IMETRIC_PROP_NAMES = Object.assign(Object.assign({}, ICOMPUTATION_PROP_NAMES), { levels: '@Levels', colorScheme: '@ColorScheme', foray_definition: 'foray:Definition', foray_description: 'foray:Description', foray_displayName: 'foray:DisplayName' });
export const ICOLUMN_PROP_NAMES = Object.assign(Object.assign({}, ICOMPUTATION_PROP_NAMES), { type: '@Type', isPublic: '@IsPublic', level: '@Level' });

//# sourceMappingURL=MDLComputations.constants.js.map
